function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire546c"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire546c"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRequire.register("4wLdb", function(module, exports) {

$parcel$export(module.exports, "WgmController", () => WgmController, (v) => WgmController = v);
// license:BSD-3-Clause
// copyright-holders:Hiromasa Tanaka

var $2gP1w = parcelRequire("2gP1w");

var $bHfhW = parcelRequire("bHfhW");

class WgmController {
    /**
     * Constructor
     *
     * @param {ArrayBuffer} module WebAssembly module binary
     * @param {number} samplingRate Sampling rate
     * @param {number} loopMaxCount Max loop count
     */ constructor(module, samplingRate, loopMaxCount){
        // WebAssembly binary
        this.module = module;
        // Worker and Worklet
        this.worklet = null;
        this.worker = null;
        this.callback = null;
        // shared memory Worker, Worklet
        this.sharedRingL = [];
        this.sharedRingR = [];
        this.sharedStatus = null;
        // sampling rate
        this.samplingRate = samplingRate;
        this.loopMaxCount = loopMaxCount;
        this.chunkSize = $2gP1w.AUDIO_WORKLET_SAMPLING_CHUNK * $2gP1w.BUFFERING_CHUNK_COUNT;
        this.feedOutRemain = 1; // 1chunk
        this.feedOutSecond = Math.floor(this.chunkSize * this.feedOutRemain / samplingRate);
        // init audio contexts
        this.context = null;
        this.gain = null;
        this.analyser = null;
        this.analyserBuffer = null;
        this.analyserBufferLength = null;
    }
    /**
     * prepare AudioContext and AudioWorklet
     *
     * Create Worklet and compile Webassembly in Worklet
     *
     * @param {AudioContext} context AudioContext
     */ async prepare(context, callback) {
        // set audio context
        this.context = context;
        // create shared memory
        try {
            for(let i = 0; i < $2gP1w.BUFFER_RING_COUNT; i++){
                this.sharedRingL[i] = new SharedArrayBuffer(this.chunkSize * 4); // * 4: Float32Array;
                this.sharedRingR[i] = new SharedArrayBuffer(this.chunkSize * 4); // * 4: Float32Array;
            }
            this.sharedStatus = new SharedArrayBuffer(1024); // Int32Array
        } catch (e) {
            return false;
        }
        // create Worker
        this.worker = new Worker((parcelRequire("eP3uQ")));
        this.worker.onmessage = (event)=>this.dispatch(event);
        // create and compile Wasm Worker
        this.sendWorker({
            "message": "compile",
            "shared": {
                "ringL": this.sharedRingL,
                "ringR": this.sharedRingR,
                "status": this.sharedStatus
            }
        }, async ()=>{
            // create worklet
            await this.context.audioWorklet.addModule((0, (/*@__PURE__*/$parcel$interopDefault($bHfhW))));
            callback();
        });
        return true;
    }
    /**
     * Initialize Controller
     *
     * Initialize AudioNode Worklet and analyser
     */ init() {
        this.worklet = new AudioWorkletNode(this.context, "wgm-worklet-processor", {
            "numberOfInputs": 1,
            "numberOfOutputs": 1,
            "outputChannelCount": [
                2
            ],
            "processorOptions": {
                "ringL": this.sharedRingL,
                "ringR": this.sharedRingR,
                "status": this.sharedStatus,
                "chunkSteps": $2gP1w.BUFFERING_CHUNK_COUNT
            }
        });
        // message dispatch
        this.worklet.port.onmessage = (event)=>this.dispatch(event);
        // connect gain
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        // connect node
        this.worklet.connect(this.gain);
        // connect fft
        this.analyser = this.context.createAnalyser();
        this.analyserBufferLength = this.analyser.frequencyBinCount;
        this.analyserBuffer = new Uint8Array(this.analyserBufferLength);
        this.analyser.getByteTimeDomainData(this.analyserBuffer);
        this.gain.connect(this.analyser);
    }
    /**
     * Instance ready?
     *
     * @returns {boolean}
     */ ready() {
        if (this.worklet == null) return false;
        return true;
    }
    /**
     * Create playable instance
     *
     * @param {ArrayBuffer} wgmdata
     * @param {string} type(vgm|xgm)
     * @param {Function} callback(gd3meta)
     */ create(wgmdata, type, callback) {
        // Stop the current loop if there is one
        // Stop Atomic wait via Worklet
        this.sendWorklet({
            "message": "stop"
        }, ()=>{
            this.sendWorker({
                "message": "create",
                "wgmdata": wgmdata,
                "type": type,
                "options": {
                    "samplingRate": this.samplingRate,
                    "chunkSize": this.chunkSize,
                    "loopMaxCount": this.loopMaxCount,
                    "feedOutRemain": this.feedOutRemain
                }
            }, callback);
        });
    }
    /**
     * Start playback
     *
     * @param {Function} callback end music callback
     */ play(callback) {
        // return to 1.0
        this.gain.gain.setValueAtTime(1, this.context.currentTime);
        // start buffering
        this.sendWorker({
            "message": "start"
        });
        // start playback
        this.sendWorklet({
            "message": "play"
        }, callback);
    }
    /**
     * Get FFT data current time
     *
     * @returns FFT array buffer
     */ getByteFrequencyData() {
        this.analyser.getByteFrequencyData(this.analyserBuffer);
        return this.analyserBuffer;
    }
    /**
     * Get FFT data length
     *
     * @returns FFT array length
     */ getAnalyserBufferLength() {
        return this.analyserBufferLength;
    }
    /**
     * Feed out music
     */ feedout() {
        const now = this.context.currentTime;
        // feed out to 0.0
        this.gain.gain.setValueAtTime(1, now);
        this.gain.gain.linearRampToValueAtTime(0, now + this.feedOutSecond);
    }
    /**
     * Message dispatcher
     *
     * @param {*} event
     */ async dispatch(event) {
        switch(event.data.message){
            case "callback":
                if (this.callback != null) await this.callback(event.data.data);
                break;
            case "feedout":
                this.feedout();
                break;
        }
    }
    /**
     * Send message to Worklet
     *
     * @param {*} message
     * @param {Function} callback
     */ sendWorklet(message, callback) {
        // wait for a reply from the worklet
        if (callback != null) this.callback = callback;
        else this.callback = null;
        // sends a message to the Worklet
        this.worklet.port.postMessage(message);
    }
    /**
     * Send message to Worklet
     *
     * @param {*} message
     * @param {Function} callback
     */ sendWorker(message, callback) {
        // wait for a reply from the worklet
        if (callback != null) this.callback = callback;
        else this.callback = null;
        // sends a message to the Worklet
        this.worker.postMessage(message);
    }
}

});
parcelRequire.register("2gP1w", function(module, exports) {

$parcel$export(module.exports, "AUDIO_WORKLET_SAMPLING_CHUNK", () => $1a74a79c52946617$export$82474fc2c4d8bff0);
$parcel$export(module.exports, "BUFFERING_CHUNK_COUNT", () => $1a74a79c52946617$export$6a88b8329b4d35e5);
$parcel$export(module.exports, "BUFFER_RING_COUNT", () => $1a74a79c52946617$export$2497303df528ce88);
// license:BSD-3-Clause
// copyright-holders:Hiromasa Tanaka
// Audio
const $1a74a79c52946617$export$82474fc2c4d8bff0 = 128;
const $1a74a79c52946617$export$6a88b8329b4d35e5 = 768;
const $1a74a79c52946617$export$2497303df528ce88 = 4;
const $1a74a79c52946617$export$ffb92b2c1007a737 = 999;
const $1a74a79c52946617$export$aa5620a1095cbc3 = 0;
const $1a74a79c52946617$export$686712ca8e49fc53 = 1;
const $1a74a79c52946617$export$8d600c44ffe6cb9e = 2;

});

parcelRequire.register("bHfhW", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("frDq4"), import.meta.url).toString();

});

parcelRequire.register("eP3uQ", function(module, exports) {

var $7ryUf = parcelRequire("7ryUf");

let $aca88a72491dc3ac$var$url = new URL((parcelRequire("27Lyk")).resolve("eDdCm"), import.meta.url);
module.exports = $7ryUf($aca88a72491dc3ac$var$url.toString(), $aca88a72491dc3ac$var$url.origin, true);

});
parcelRequire.register("7ryUf", function(module, exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};

});



var $574b4c9dc2af2036$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"g3LtT":"index.bdfdbb3e.js","frDq4":"wgm_worklet_processor.4d3ce39b.js","eDdCm":"wgm_worker.76908457.js","Sv3zf":"wgm_worker.2b5342f9.js","fpIuB":"libymfm_bg.496732f9.wasm"}'));

// license:BSD-3-Clause
// copyright-holders:Hiromasa Tanaka

var $4wLdb = parcelRequire("4wLdb");
/**
 * VGM setting
 */ const $54b47fc030b7b21e$var$DEFAULT_SAMPLING_RATE = 44100;
const $54b47fc030b7b21e$var$LOOP_MAX_COUNT = 2;
/**
  * Canvas settings
  */ const $54b47fc030b7b21e$var$CANVAS_WIDTH = 768;
const $54b47fc030b7b21e$var$CANVAS_HEIGHT = 576;
const $54b47fc030b7b21e$var$COLOR_MD_GREEN = "#00a040";
const $54b47fc030b7b21e$var$COLOR_MD_RED = "#e60012";
const $54b47fc030b7b21e$var$FONT_MAIN_STYLE = "16px sans-serif";
/**
 * AudioWorklet Player
 * @type {WgmController}
 */ let $54b47fc030b7b21e$var$player;
/**
 * Audio context
 * @type {AudioContext}
 */ let $54b47fc030b7b21e$var$audioContext = null;
let $54b47fc030b7b21e$var$isAudioContextOpen = false;
/**
 * VGM member
 */ let $54b47fc030b7b21e$var$playlist = [];
let $54b47fc030b7b21e$var$totalPlaylistCount;
let $54b47fc030b7b21e$var$musicMeta;
let $54b47fc030b7b21e$var$samplingRate = $54b47fc030b7b21e$var$DEFAULT_SAMPLING_RATE;
/**
 * Canvas
 * @type {HTMLCanvasElement}
 */ let $54b47fc030b7b21e$var$canvas;
/**
 * CanvasContext
 * @type {CanvasRenderingContext2D}
 */ let $54b47fc030b7b21e$var$canvasContext;
let $54b47fc030b7b21e$var$animId = null;
/**
 * Canvas setting
 */ (function() {
    $54b47fc030b7b21e$var$canvas = document.getElementById("screen");
    $54b47fc030b7b21e$var$canvas.setAttribute("width", $54b47fc030b7b21e$var$CANVAS_WIDTH);
    $54b47fc030b7b21e$var$canvas.setAttribute("height", $54b47fc030b7b21e$var$CANVAS_HEIGHT);
    let pixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
    if (pixelRatio > 1 && window.screen.width < $54b47fc030b7b21e$var$CANVAS_WIDTH) {
        $54b47fc030b7b21e$var$canvas.style.width = "320px";
        $54b47fc030b7b21e$var$canvas.style.heigth = "240px";
    }
    $54b47fc030b7b21e$var$canvasContext = $54b47fc030b7b21e$var$canvas.getContext("2d");
    $54b47fc030b7b21e$var$canvasContext.font = "20px sans-serif";
    $54b47fc030b7b21e$var$canvasContext.fillStyle = $54b47fc030b7b21e$var$COLOR_MD_GREEN;
    // now loading
    const nowloading = "Now Loading...";
    let left = ($54b47fc030b7b21e$var$CANVAS_WIDTH - $54b47fc030b7b21e$var$canvasContext.measureText(nowloading).width) / 2;
    $54b47fc030b7b21e$var$canvasContext.fillText(nowloading, left, $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 - 32);
})();
var $893d73acdfa90ef4$exports = {};

$893d73acdfa90ef4$exports = new URL((parcelRequire("27Lyk")).resolve("fpIuB"), import.meta.url).toString();


/**
 * Initialize system and start
 */ (async function() {
    /**
     * Switch sampling rate for test (ex. https://.../#s=48000)
     *
     *  let context = new AudioContext({ sampleRate: samplingRate })
     *
     * (2021/9)
     * Support Firefox only. (I haven't confirmed anything other than Linux platform)
     * In other browsers, the setting works, but the native connection to the audio interface drops to 44100Hz.
     * There is probably some downsampling going on inside the browser.
     * Also, the setting itself may be invalid in Safari.
     */ if (location.hash != "") {
        const sample = location.hash.match(/^#s=(\d+)/);
        if (sample != null) {
            $54b47fc030b7b21e$var$samplingRate = parseInt(sample[1]);
            if ($54b47fc030b7b21e$var$samplingRate != $54b47fc030b7b21e$var$samplingRate /* isNan */  || !($54b47fc030b7b21e$var$samplingRate == 44100 || $54b47fc030b7b21e$var$samplingRate == 48000 || $54b47fc030b7b21e$var$samplingRate == 88200 || $54b47fc030b7b21e$var$samplingRate == 96000)) $54b47fc030b7b21e$var$samplingRate = $54b47fc030b7b21e$var$DEFAULT_SAMPLING_RATE;
        }
    }
    /**
     * Pre-fetch WebAssemby binary module
     */ let module = await fetch(new URL($893d73acdfa90ef4$exports));
    module = new Uint8Array(await module.arrayBuffer());
    $54b47fc030b7b21e$var$player = new (0, $4wLdb.WgmController)(module, $54b47fc030b7b21e$var$samplingRate, $54b47fc030b7b21e$var$LOOP_MAX_COUNT);
    /**
     * Create AudioContext and load WebAssembly module
     */ $54b47fc030b7b21e$var$audioContext = new (window.AudioContext || window.webkitAudioContext)({
        sampleRate: $54b47fc030b7b21e$var$samplingRate
    });
    if (!await $54b47fc030b7b21e$var$player.prepare($54b47fc030b7b21e$var$audioContext, ()=>{
        /**
         * Start event loop
         */ $54b47fc030b7b21e$var$start();
    })) $54b47fc030b7b21e$var$systemError();
})();
/**
 * Start event loop
 */ const $54b47fc030b7b21e$var$start = ()=>{
    // print information
    $54b47fc030b7b21e$var$title();
    $54b47fc030b7b21e$var$canvasContext.fillStyle = $54b47fc030b7b21e$var$COLOR_MD_GREEN;
    $54b47fc030b7b21e$var$canvasContext.font = "14px sans-serif";
    $54b47fc030b7b21e$var$fillTextCenterd("YM2149 | YM2151 | YM2203 | YM2413 | YM2608 | YM2610(B) | YM2612 | YM3526 | Y8950 | YM3812 | YMF262 | YMF278B", $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 - 128 + 16);
    $54b47fc030b7b21e$var$fillTextCenterd("SN76489(MD) | PWM(32X) | SEGAPCM | OKIM6258(X68K) | C140(C219) | OKIM6295", $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 - 96 + 4);
    $54b47fc030b7b21e$var$canvasContext.font = "20px sans-serif";
    $54b47fc030b7b21e$var$fillTextCenterd("\uD83C\uDFB6 DRAG AND DROP VGM(vgm/vgz) || XGM(xgm/xgz) HEAR", $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 - 32);
    $54b47fc030b7b21e$var$canvasContext.font = "15px sans-serif";
    $54b47fc030b7b21e$var$fillTextCenterd("or click to play sample music", $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 + 32);
    $54b47fc030b7b21e$var$printStatus();
    // Set UI event
    $54b47fc030b7b21e$var$canvas.addEventListener("dragover", function(e) {
        $54b47fc030b7b21e$var$prevent(e);
        $54b47fc030b7b21e$var$canvas.style.border = "4px dotted #333333";
        return false;
    }, false);
    $54b47fc030b7b21e$var$canvas.addEventListener("dragleave", function(e) {
        $54b47fc030b7b21e$var$prevent(e);
        $54b47fc030b7b21e$var$canvas.style.border = "4px solid #000";
        return false;
    });
    // drag to play
    $54b47fc030b7b21e$var$canvas.addEventListener("drop", $54b47fc030b7b21e$var$onDrop, false);
    // for sample music data
    $54b47fc030b7b21e$var$canvas.addEventListener("click", $54b47fc030b7b21e$var$sample, false);
};
/**
 * System error
 */ const $54b47fc030b7b21e$var$systemError = ()=>{
    $54b47fc030b7b21e$var$title();
    $54b47fc030b7b21e$var$fillTextCenterd("System initialize error.", $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 - 64);
    $54b47fc030b7b21e$var$canvasContext.font = "20px sans-serif";
    $54b47fc030b7b21e$var$canvasContext.fillStyle = $54b47fc030b7b21e$var$COLOR_MD_GREEN;
    $54b47fc030b7b21e$var$fillTextCenterd("Your browser does not support SharedArrayBuffer.", $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2);
    $54b47fc030b7b21e$var$fillTextCenterd("SharedArrayBuffer is supported by Firefox or Chromium systems.", $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 + 32);
// if(crossOriginIsolated) { // eslint-disable-line no-undef
//     fillTextCenterd("crossOriginIsolated is not set on the server.", CANVAS_HEIGHT / 2);
// }
// no set event loop
};
/**
 * Title screen
 */ const $54b47fc030b7b21e$var$title = ()=>{
    $54b47fc030b7b21e$var$canvasContext.fillStyle = "rgb(0, 0, 0)";
    $54b47fc030b7b21e$var$canvasContext.fillRect(0, 0, $54b47fc030b7b21e$var$CANVAS_WIDTH, $54b47fc030b7b21e$var$CANVAS_HEIGHT);
    $54b47fc030b7b21e$var$canvasContext.font = "bold 28px sans-serif";
    $54b47fc030b7b21e$var$canvasContext.fillStyle = $54b47fc030b7b21e$var$COLOR_MD_RED;
    $54b47fc030b7b21e$var$fillTextCenterd("WebAssembly \uD83C\uDFAE VGM Player", $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 - 160);
};
/**
 * Ready to play screen
 */ const $54b47fc030b7b21e$var$ready = ()=>{
    $54b47fc030b7b21e$var$title();
    $54b47fc030b7b21e$var$canvasContext.font = "28px sans-serif";
    $54b47fc030b7b21e$var$canvasContext.fillStyle = $54b47fc030b7b21e$var$COLOR_MD_GREEN;
    $54b47fc030b7b21e$var$fillTextCenterd("OK! CLICK or TAP to start playback!", $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 + 192);
    // Playback icon
    $54b47fc030b7b21e$var$canvasContext.arc($54b47fc030b7b21e$var$CANVAS_WIDTH / 2, $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2, $54b47fc030b7b21e$var$CANVAS_WIDTH / 8, 0 * Math.PI / 180, 360 * Math.PI / 180, false);
    $54b47fc030b7b21e$var$canvasContext.fillStyle = $54b47fc030b7b21e$var$COLOR_MD_RED;
    $54b47fc030b7b21e$var$canvasContext.fill();
    $54b47fc030b7b21e$var$canvasContext.beginPath();
    $54b47fc030b7b21e$var$canvasContext.moveTo($54b47fc030b7b21e$var$CANVAS_WIDTH / 2 - 50 + 10, $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 - 50);
    $54b47fc030b7b21e$var$canvasContext.lineTo($54b47fc030b7b21e$var$CANVAS_WIDTH / 2 - 50 + 10, $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 + 50);
    $54b47fc030b7b21e$var$canvasContext.lineTo($54b47fc030b7b21e$var$CANVAS_WIDTH / 2 + 50 + 10, $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2);
    $54b47fc030b7b21e$var$canvasContext.closePath();
    $54b47fc030b7b21e$var$canvasContext.strokeStyle = "#ffffff";
    $54b47fc030b7b21e$var$canvasContext.stroke();
    $54b47fc030b7b21e$var$canvasContext.fillStyle = "#ffffff";
    $54b47fc030b7b21e$var$canvasContext.fill();
    $54b47fc030b7b21e$var$isAudioContextOpen = true;
    $54b47fc030b7b21e$var$canvas.addEventListener("click", $54b47fc030b7b21e$var$next, false);
};
/**
 * Sample music
 */ const $54b47fc030b7b21e$var$sample = async ()=>{
    // sample music one time
    $54b47fc030b7b21e$var$canvas.removeEventListener("click", $54b47fc030b7b21e$var$sample, false);
    // it takes precedence over VGM metadata
    $54b47fc030b7b21e$var$musicMeta = $54b47fc030b7b21e$var$createGd3meta({
        track_name: "\uD83E\uDD0D Thank you for trying this player",
        track_name_j: "",
        game_name: "",
        game_name_j: "A synthesizer written in WebAssembly",
        track_author: "See the GitHub repository for more information",
        track_author_j: ""
    });
    const response = await fetch("./vgm/ym2612.vgm");
    const bytes = await response.arrayBuffer();
    // The sample music starts playing by clicking on it.
    $54b47fc030b7b21e$var$isAudioContextOpen = true;
    // Play sample music
    $54b47fc030b7b21e$var$play(bytes, "vgm", $54b47fc030b7b21e$var$musicMeta);
};
/**
 * Event prevent
 *
 * @param {Event} e
 */ const $54b47fc030b7b21e$var$prevent = function(e) {
    e.preventDefault();
    e.stopPropagation();
};
/**
 * Drag and Drop
 *
 * @param {DragEvent} ev
 * @returns false (prevent event)
 */ const $54b47fc030b7b21e$var$onDrop = (ev)=>{
    $54b47fc030b7b21e$var$prevent(ev);
    // sample music one time
    $54b47fc030b7b21e$var$canvas.removeEventListener("click", $54b47fc030b7b21e$var$sample, false);
    // pause the drop event
    $54b47fc030b7b21e$var$canvas.removeEventListener("drop", $54b47fc030b7b21e$var$onDrop, false);
    $54b47fc030b7b21e$var$canvas.style.border = "4px solid #000";
    let filelist = {};
    let files = ev.dataTransfer.files;
    [].forEach.call(files, function(file) {
        let reader = new FileReader();
        reader.onload = function() {
            filelist[file.name] = reader.result;
            if (Object.keys(filelist).length >= files.length) {
                // resume the drop event
                $54b47fc030b7b21e$var$canvas.addEventListener("drop", $54b47fc030b7b21e$var$onDrop, false);
                $54b47fc030b7b21e$var$playlist = [];
                Object.keys(filelist).sort().forEach(function(key) {
                    $54b47fc030b7b21e$var$playlist.push({
                        filename: key,
                        xgmdata: filelist[key]
                    });
                });
                $54b47fc030b7b21e$var$totalPlaylistCount = $54b47fc030b7b21e$var$playlist.length;
                if (!$54b47fc030b7b21e$var$isAudioContextOpen) $54b47fc030b7b21e$var$ready();
                else $54b47fc030b7b21e$var$next();
            }
        };
        reader.readAsArrayBuffer(file);
    });
    return false;
};
/**
 * Play next playlist
 */ const $54b47fc030b7b21e$var$next = function() {
    $54b47fc030b7b21e$var$canvas.removeEventListener("click", $54b47fc030b7b21e$var$next, false);
    if ($54b47fc030b7b21e$var$playlist.length <= 0) return;
    const target = $54b47fc030b7b21e$var$playlist.shift();
    let type = "vgm";
    if (/\.xg[m|z]$/.test(target.filename)) type = "xgm";
    $54b47fc030b7b21e$var$play(target.xgmdata, type);
};
/**
 * Play Music
 *
 * @param {ArrayBuffer} xgmfile
 * @param {string} type(vgm|xgm)
 * @param {*} altMeta
 */ const $54b47fc030b7b21e$var$play = function(xgmfile, type, altMeta) {
    // Worklet exchange callbacks
    // iOS only sounds AudioWorklet that created by the click event.
    // In the case of ScriptProcessorNode, I had to create an AudioContext here.
    if (!$54b47fc030b7b21e$var$player.ready()) {
        // for Chromium
        // "The AudioContext was not allowed to start.
        //  It must be resumed (or created) after a user gesture on the page."
        $54b47fc030b7b21e$var$audioContext.resume();
        // create audionode and gain
        $54b47fc030b7b21e$var$player.init();
    }
    $54b47fc030b7b21e$var$player.create(xgmfile, type, (gd3)=>{
        if (altMeta == null) $54b47fc030b7b21e$var$musicMeta = $54b47fc030b7b21e$var$createGd3meta(gd3);
        if ($54b47fc030b7b21e$var$animId != null) {
            window.cancelAnimationFrame($54b47fc030b7b21e$var$animId);
            $54b47fc030b7b21e$var$animId = null;
        }
        $54b47fc030b7b21e$var$draw();
        $54b47fc030b7b21e$var$player.play($54b47fc030b7b21e$var$next);
    });
};
/**
 * Create GD3 meta
 *
 * @param {*} meta
 * @returns
 */ const $54b47fc030b7b21e$var$createGd3meta = function(meta) {
    meta.game_track_name = [
        meta.game_name,
        meta.track_name
    ].filter((str)=>str != "").join(" | ");
    meta.game_track_name_j = [
        meta.game_name_j,
        meta.track_name_j
    ].filter((str)=>str != "").join(" / ");
    meta.track_author_full = [
        meta.track_author,
        meta.track_author_j
    ].filter((str)=>str != "").join(" - ");
    $54b47fc030b7b21e$var$canvasContext.font = $54b47fc030b7b21e$var$FONT_MAIN_STYLE;
    meta.game_track_name_left = ($54b47fc030b7b21e$var$CANVAS_WIDTH - $54b47fc030b7b21e$var$canvasContext.measureText(meta.game_track_name).width) / 2;
    meta.game_track_name_j_left = ($54b47fc030b7b21e$var$CANVAS_WIDTH - $54b47fc030b7b21e$var$canvasContext.measureText(meta.game_track_name_j).width) / 2;
    meta.track_author_full_left = ($54b47fc030b7b21e$var$CANVAS_WIDTH - $54b47fc030b7b21e$var$canvasContext.measureText(meta.track_author_full).width) / 2;
    return meta;
};
/**
 * Draw
 */ const $54b47fc030b7b21e$var$draw = function() {
    $54b47fc030b7b21e$var$animId = window.requestAnimationFrame($54b47fc030b7b21e$var$draw);
    $54b47fc030b7b21e$var$canvasContext.fillStyle = "rgb(0, 0, 0)";
    $54b47fc030b7b21e$var$canvasContext.fillRect(0, 0, $54b47fc030b7b21e$var$CANVAS_WIDTH, $54b47fc030b7b21e$var$CANVAS_HEIGHT);
    let audioAnalyserBuffer = $54b47fc030b7b21e$var$player.getByteFrequencyData();
    let audioAnalyserBufferLength = $54b47fc030b7b21e$var$player.getAnalyserBufferLength();
    $54b47fc030b7b21e$var$canvasContext.lineWidth = 1;
    $54b47fc030b7b21e$var$canvasContext.beginPath();
    $54b47fc030b7b21e$var$canvasContext.strokeStyle = $54b47fc030b7b21e$var$COLOR_MD_RED;
    let width = 4;
    let step = Math.round(audioAnalyserBufferLength / ($54b47fc030b7b21e$var$CANVAS_WIDTH / width));
    $54b47fc030b7b21e$var$canvasContext.setLineDash([
        2,
        1
    ]);
    $54b47fc030b7b21e$var$canvasContext.lineWidth = width;
    for(var i = 0; i < audioAnalyserBufferLength; i += step){
        $54b47fc030b7b21e$var$canvasContext.beginPath();
        $54b47fc030b7b21e$var$canvasContext.moveTo(i + 2, $54b47fc030b7b21e$var$CANVAS_HEIGHT);
        $54b47fc030b7b21e$var$canvasContext.lineTo(i + 2, $54b47fc030b7b21e$var$CANVAS_HEIGHT - audioAnalyserBuffer[i] * 1.5);
        $54b47fc030b7b21e$var$canvasContext.stroke();
    }
    $54b47fc030b7b21e$var$canvasContext.stroke();
    $54b47fc030b7b21e$var$canvasContext.font = "12px monospace";
    $54b47fc030b7b21e$var$canvasContext.fillStyle = $54b47fc030b7b21e$var$COLOR_MD_GREEN;
    if ($54b47fc030b7b21e$var$totalPlaylistCount >= 1) $54b47fc030b7b21e$var$fillTextCenterd("Track " + ($54b47fc030b7b21e$var$totalPlaylistCount - $54b47fc030b7b21e$var$playlist.length) + " / " + $54b47fc030b7b21e$var$totalPlaylistCount, $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 - 96);
    $54b47fc030b7b21e$var$canvasContext.font = $54b47fc030b7b21e$var$FONT_MAIN_STYLE;
    $54b47fc030b7b21e$var$canvasContext.fillText($54b47fc030b7b21e$var$musicMeta.game_track_name, $54b47fc030b7b21e$var$musicMeta.game_track_name_left, $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 - 64);
    $54b47fc030b7b21e$var$canvasContext.fillText($54b47fc030b7b21e$var$musicMeta.game_track_name_j, $54b47fc030b7b21e$var$musicMeta.game_track_name_j_left, $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2 - 32);
    $54b47fc030b7b21e$var$canvasContext.fillText($54b47fc030b7b21e$var$musicMeta.track_author_full, $54b47fc030b7b21e$var$musicMeta.track_author_full_left, $54b47fc030b7b21e$var$CANVAS_HEIGHT / 2);
    $54b47fc030b7b21e$var$printStatus();
};
/**
 * Print status
 */ const $54b47fc030b7b21e$var$printStatus = function() {
    if ($54b47fc030b7b21e$var$samplingRate == 44100) return;
    const status = " HD:" + $54b47fc030b7b21e$var$samplingRate + " ";
    $54b47fc030b7b21e$var$canvasContext.font = "16px sans-serif";
    const measure = $54b47fc030b7b21e$var$canvasContext.measureText(status);
    $54b47fc030b7b21e$var$canvasContext.fillStyle = $54b47fc030b7b21e$var$COLOR_MD_GREEN;
    $54b47fc030b7b21e$var$canvasContext.fillRect($54b47fc030b7b21e$var$CANVAS_WIDTH - measure.width, 0, $54b47fc030b7b21e$var$CANVAS_WIDTH, 18);
    $54b47fc030b7b21e$var$canvasContext.fillStyle = "rgb(0, 0, 0)";
    $54b47fc030b7b21e$var$canvasContext.fillText(status, $54b47fc030b7b21e$var$CANVAS_WIDTH - measure.width, 16);
};
/**
 * Fill text center
 *
 * @param {*} str
 * @param {*} height
 */ const $54b47fc030b7b21e$var$fillTextCenterd = function(str, height) {
    let left = ($54b47fc030b7b21e$var$CANVAS_WIDTH - $54b47fc030b7b21e$var$canvasContext.measureText(str).width) / 2;
    $54b47fc030b7b21e$var$canvasContext.fillText(str, left, height);
};


//# sourceMappingURL=index.bdfdbb3e.js.map
